<template>
  <LoaderWrapper ref="pageLoader" class="h-100">
    <div  class="row" :class="mainClass ?? 'm-4 mt-0'">
      <div class="col-sm-12">
        <div class="row">

          <div class="col-sm-12">
            <div class="card card-body mb-0">

              <div class="row mt-2">

                <div class="form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2">
                  <div class="col p-0">
                    <div class="">
                      <input type="text" class="form-control form-control-sm" :placeholder="helper.trans('labels.invoice_id')" v-model="requestDTO.dealId">
                    </div>
                  </div>
                </div>

                <div class="form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2">
                  <div class="col p-0">
                    <div class="">
                      <DatePicker v-model="requestDTO.fromDate" mode="dateTime" :model-modifiers="{string: true}"  is24hr :masks="{modelValue: 'YYYY-MM-DD HH:mm:ss', inputDateTime24hr: 'YYYY-MM-DD HH:mm:ss'}">
                        <template v-slot="{ inputValue, togglePopover, inputEvents }">
                          <input
                            class="form-control form-control-sm"
                            :placeholder="helper.trans('labels.from_date')"
                            :value="inputValue"
                            @focus="togglePopover"
                            @change="inputEvents.change"
                          />
                        </template>
                      </DatePicker>
                    </div>
                  </div>
                </div>

                <div class="form-group mb-2 me-2 col-md-3 col-lg-3 col-xl-2">
                  <div class="col p-0">
                    <div class="">
                      <DatePicker v-model="requestDTO.toDate" mode="dateTime" :model-modifiers="{string: true}"  is24hr :masks="{modelValue: 'YYYY-MM-DD HH:mm:ss', inputDateTime24hr: 'YYYY-MM-DD HH:mm:ss'}">
                        <template v-slot="{ inputValue, togglePopover, inputEvents }">
                          <input
                            class="form-control form-control-sm"
                            :placeholder="helper.trans('labels.to_date')"
                            :value="inputValue"
                            @focus="togglePopover"
                            @change="inputEvents.change"
                          />
                        </template>
                      </DatePicker>
                    </div>
                  </div>
                </div>

                <div class="form-group mb-2 col-md-3 col-lg-3 col-xl-2 me-2">
                  <div class="col p-0">
                    <div class="">
                      <Multiselect id="types"
                                   class="multiselect-sm"
                                   v-model="requestDTO.types"
                                   :options="Object.values(OperationType)"
                                   :custom-label="(opt) => helper.trans(`operation_type.${opt}`)"
                                   :multiple="true"
                                   select-label="Select"
                                   :placeholder="helper.trans('labels.type')"
                      >
                      </Multiselect>
                    </div>
                  </div>
                </div>

                <div class="form-group mb-2 col">
                  <div class="col-auto p-0 text-end ">
                    <button type="button" @click.prevent="() => exportData()" class="btn btn-outline-success btn-sm rounded-pill me-2 text-capitalize-first">
                      <i class="fa fa-download me-1"></i>{{ helper.trans('button.export') }}
                    </button>
                    <button type="button" @click.prevent="() => applyFilters()" class="btn btn-outline-primary btn-sm rounded-pill me-2 text-capitalize-first">{{ helper.trans('button.apply') }}</button>
                    <button type="button" @click.prevent="() => clearFilters()" class="btn btn-outline-secondary btn-sm rounded-pill text-capitalize-first">{{ helper.trans('button.reset') }}</button>
                  </div>
                </div>

              </div>
            </div>
          </div>

          <div class="col-sm-12">
            <div class="card card-body">
              <div class="overflow-auto">

                <b-modal dialog-class="modal-lg"
                         :title="trans('labels.operation_details')"
                         :modelValue="detailsOperation !== null"
                         body-class="pt-0"
                         @update:modelValue="$event === false && (detailsOperation = null)"
                >
                  <template #default>
                    <OperationDetails :operation="detailsOperation"></OperationDetails>
                  </template>
                  <template #footer>
                    <button type="button" v-on:click="detailsOperation = null" class="btn btn-outline-dark btn-sm text-capitalize-first">
                      {{ trans('button.close')}}
                    </button>
                  </template>
                </b-modal>

                <table class="table table-striped border-light align-middle text-left text-nowrap position-relative">
                  <thead>
                  <tr>
                    <th class="text-capitalize-first">{{ trans("labels.date") }}</th>
                    <th class="text-capitalize-first">{{ trans("labels.currency") }}</th>
                    <th class="text-capitalize-first">{{ trans("labels.amount") }}</th>
                    <th class="text-capitalize-first">{{ trans("labels.type") }}</th>
                    <th class="text-capitalize-first">{{ trans("labels.balance_before") }}</th>
                    <th class="text-capitalize-first">{{ trans("labels.balance_after") }}</th>
                    <th></th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="operation in operations.items" :key="operation.id" :class="{'text-success': operation.transactionType === TransactionType.CREDIT, 'text-danger': operation.transactionType !== TransactionType.CREDIT}">
                    <td>{{ dateHelper.format(operation.createdAt) }}</td>
                    <td>{{ operation.currency }}</td>
                    <td>{{ operation.transactionType === TransactionType.CREDIT ? "+" : '-' }}{{ numberFormatter.formatNumber(operation.sum)}}</td>
                    <td>{{ trans('operation_type.' + operation.operationType) }}</td>
                    <td>{{ numberFormatter.formatNumber(operation.balanceBefore)}}</td>
                    <td>{{ numberFormatter.formatNumber(operation.balanceAfter)}}</td>
                    <td class="text-end">
                      <button type="button" @click="detailsOperation = operation" class="btn btn-sm btn-outline-dark text-nowrap text-capitalize"><i class="fa fa-list"></i>
                        {{ trans('button.details') }}</button>
                    </td>
                  </tr>
                  </tbody>
                </table>

                <b-pagination
                  v-if="operations.totalCount > operations.items.length"
                  v-model="page"
                  :total-rows="operations.totalCount"
                  :per-page="operations.limit"
                  :limit="20"
                  @update:modelValue="loadOperations()"
                  :prev-text="trans('button.back')"
                  :next-text="trans('button.next')"
                  align="start"
                  first-number
                  hide-goto-end-buttons
                  hide-ellipsis
                ></b-pagination>
              </div>

            </div>
          </div>

        </div>
      </div>
    </div>
  </LoaderWrapper>
</template>
<script lang="ts">
import LoaderWrapper from "@/components/LoaderWrapper.vue";
import {defineComponent, onMounted, ref, ComputedRef, computed, PropType, Prop} from 'vue'
import {reactive, toRefs} from "@vue/reactivity";
import {dateHelper} from "@/service/DateHelper";
import {numberFormatter} from "@/service/NumberFormatter";
import APIClient from "@/service/APIClient";
import AccountOperationDTO from "@/models/AccountOperationDTO";
import PaginatedResponseDTO from "@/models/PaginatedResponseDTO";
import {TransactionType} from "@/models/enum/TransactionType";
import {helper, trans} from "@/service/CommonHelper";
import {BModal, BPagination} from "bootstrap-vue-3";
import OperationDetails from "@/components/OperationDetails.vue";
import {useStore} from "vuex";
import MerchantStoreDTO from "@/models/MerchantStoreDTO";
import AccountOperationsGetRequestDTO from "@/models/request/AccountOperationsGetRequestDTO";
import {useRoute} from "vue-router";
import AccountDTO from "@/models/AccountDTO";
import {DatePicker} from "v-calendar";
import {OperationType} from "@/models/enum/OperationType";
import Multiselect from "vue-multiselect";
import moment from "moment/moment";
import {useNotification} from "@kyvg/vue3-notification";

const api = new APIClient();

const defaultRequestDTO = {
    currency: null,
    dealId: '',
    storeIds: [],
    types: [],
    fromDate: moment().subtract(7, 'day').format('YYYY-MM-DD 00:00:00'),
    toDate: null,
    ids: []
  } as AccountOperationsGetRequestDTO;

export default defineComponent({
  name: 'AccountOperations',
  components: {
    Multiselect,
    DatePicker,
    LoaderWrapper,
    BPagination,
    BModal,
    OperationDetails
  },
  props: {
    class: String,
    account: {
      type: Object as PropType<AccountDTO|null>,
      default: null
    } as Prop<AccountDTO|null>
  },
  setup(props) {
    const route = useRoute()
    const store = useStore();
    const notification = useNotification();
    const pageLoader = ref<InstanceType<typeof LoaderWrapper> | null>(null)
    const currentStore = computed<MerchantStoreDTO|null>(() => store.getters["merchantStores/getCurrent"]);

    const state = reactive({
      mainClass: props.class,
      detailsOperation: null as AccountOperationDTO|null,
      requestDTO: {
        ...defaultRequestDTO
      } as AccountOperationsGetRequestDTO,
      page: 1,
      operations: {
          limit: 20,
          offset: 0,
          totalCount: 0,
          items: []
      } as PaginatedResponseDTO<AccountOperationDTO>
    });

    const buildRequestParams = () => {
      if (currentStore.value !== null) {
        state.requestDTO.storeIds = [currentStore.value!.id]
      } else {
        state.requestDTO.storeIds = []
      }
      if (route.query.id) {
        state.requestDTO.ids = [route.query.id as string]
      }
      if (route.query.currency) {
        state.requestDTO.currency = route.query.currency as string
      }
      if (props.account) {
        state.requestDTO.ids = [props.account!.id]
      }
      return {
        ...state.requestDTO,
        fromDate: dateHelper.toUTC(state.requestDTO.fromDate),
        toDate: dateHelper.toUTC(state.requestDTO.toDate)
      }
    }

    const loadOperations= async () => {
      state.operations.offset = state.operations.limit * (state.page - 1)
      pageLoader.value?.show()
      state.operations = await api.accountOperations(state.operations, {createdAt: 'desc'}, buildRequestParams())
      pageLoader.value?.hide()
    }

    const exportData = async () => {
      try {
        pageLoader.value?.show()
        const blob = await api.accountOperationsExport(buildRequestParams())
        const filename = `account_operations_${moment().format('YYYY-MM-DD_HH-mm-ss')}.xlsx`
        helper.downloadBlob(blob, filename)
      } catch (e) {
        notification.notify({
          title: 'Ошибка экспорта',
          text: 'Не удалось экспортировать данные ',
          type: 'error'
        })
      } finally {
        pageLoader.value?.hide()
      }
    }

    const applyFilters = async () => {
      state.page = 1;
      loadOperations()
    }

    const clearFilters = async () => {
      state.page = 1;
      state.requestDTO = {...defaultRequestDTO}
      loadOperations()
    }

    onMounted(() => {
      loadOperations();
    });

    return {
      ...toRefs(state),
      pageLoader,
      dateHelper,
      numberFormatter,
      TransactionType,
      loadOperations,
      exportData,
      applyFilters,
      clearFilters,
      trans,
      helper,
      OperationType,
    }
  }
})
</script>
